import type { ICardState } from "../interfaces/card";

/**
 * The payment-methods payload is fresh only for the magic link and the
 * `cardList` identity it was fetched against. Adding a card replaces that
 * array while the quote page is unmounted, so a remount must refetch.
 */
export const paymentMethodsCacheIsFresh = (
  cached: { linkId: string; cardList: readonly ICardState[] } | null,
  linkId: string,
  cardList: readonly ICardState[],
): boolean =>
  !!cached && cached.linkId === linkId && cached.cardList === cardList;
